import { PRESELECTED_IDS } from '~~/modules/views/cottage-bookmarks/constants'

import type { schemaType } from '~~/shared/api/rurality/v3/bookmarks/lists/schema'
import type { CottageBookmarks } from '~~/modules/views/cottage-bookmarks/entities/CottageBookmarks'
import type { paramsType } from '~~/shared/api/rurality/v3/bookmarks/save/paramsSchema'

export const useCottageBookmarks = () => {
  const fromRuralityBookmarksDetail = (params: {
    dataIn: schemaType
  }): CottageBookmarks => {
    let items: CottageBookmarks = []

    items = params.dataIn.map(item => {
      const itemMapped: CottageBookmarks[0] = {
        value: PRESELECTED_IDS.includes(item.bookmarksListDoc.listId),
        id: item.bookmarksListDoc.listId,
        label: item.bookmarksListDoc.listName,
      }

      return itemMapped
    })

    return items
  }

  const toRuralityBookmarksSave = (params: {
    dataIn: CottageBookmarks
    cottageUid: string
  }): paramsType => {
    const filteredIds = params.dataIn
      .filter(item => item.value)
      .map(item => item.id)

    const returnObject: paramsType = {
      cottageUid: params.cottageUid,
      note: '',
      bookmarkLists: filteredIds,
    }

    return returnObject
  }

  return {
    fromRuralityBookmarksDetail,
    toRuralityBookmarksSave,
  }
}
